import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import api from '../utils/api';

// Requests a new verification email. The server answers the same way whether or not the address has an account.
export default function ResendVerification({ email }) {
  const { t } = useTranslation();
  const [status, setStatus] = useState('');
  const [busy, setBusy] = useState(false);

  const resend = async () => {
    setBusy(true);
    try {
      await api.post('/api/users/resend-verification', { email });
      setStatus('sent');
    } catch {
      setStatus('failed');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="mt-3 text-center">
      {status === 'sent' && <p className="text-sm text-gray-700 mb-2">{t('verify.resent')}</p>}
      {status === 'failed' && <p className="text-sm text-red-500 mb-2">{t('verify.sendFailed')}</p>}
      <button type="button" onClick={resend} disabled={busy} className="text-blue-600 underline disabled:opacity-50">
        {t('verify.resend')}
      </button>
    </div>
  );
}
